import State from './State.js';
import Deck from './Deck.js';
export default class StateCrib extends State {
    constructor(context) {
        super(context);
        this.name = 'crib';
    }
    setup() {

        //shuffle
        var deck = new Deck();
        deck.shuffle(this.context.cards);
        for (var i = 0; i < this.context.cards.length; i++) {
            let card = this.context.cards[i];
            card.showfront = true;
            card.owner = null;
            card.pile = "deck";
            card.pilez = i;
        }

        let dealer = this.context.dealer;
        this.cribPileName = dealer == "player1" ? "crib1" : "crib2";

        //setup hand pre-crib
        //draw 6 cards each into hand
        this.preHand1 = [];
        this.preHand2 = [];
        for (var i = 0; i < 6; i++) {
            let deck = this.context.getPile("deck");
            let topCard = deck[deck.length - 1];

            topCard.showfront = false;
            topCard.owner = "player1";
            this.context.addToPile(topCard, "hand1");
            this.preHand1.push(topCard.id);
        }
        for (var i = 0; i < 6; i++) {
            let deck = this.context.getPile("deck");
            let topCard = deck[deck.length - 1];

            topCard.showfront = false;
            topCard.owner = "player2";
            this.context.addToPile(topCard, "hand2");
            this.preHand2.push(topCard.id);
        }

        if (this.context.sortHands) {
            this.context.sortPile("hand1");
            this.context.sortPile("hand2");
        }

        // //random order
        // let  random_boolean = Math.random() >= 0.5;
        // this.context.sortPile("hand1",random_boolean);
        // this.context.sortPile("hand2",random_boolean);

        //  this.context.playerTurn = (dealer === "player1") ? "player2" : "player1";
        this.context.playerTurn = null;

        this.createMessage();

    }
    action(command, value, player) {
        switch (command) {
            case "play": return this.select(value, player); break;
            case "select": return this.select(value, player); break;
            case "sort": return this.sort(value, player); break;
            case "confirm": return this.confirm(value, player); break;
            case "playCribCard": return this.playCribCard(value, player); break;
            case "playAllCribCards": return this.playAllCribCards(value, player); break;
            default: this.unknownCommand(command, value, player);
        }

    }
    getActions(player) {
        let actions = [];

        //todo: remove turns
        //if (this.context.playerTurn !== player) return [];

        let playerHandName = player === "player1" ? "hand1" : "hand2";
        let pileHand = this.context.getPile(playerHandName);
        let selectedCards = pileHand.filter(card => card.isSelected);

        if (selectedCards.length !== 2) {
            if (pileHand.length > 4) {//don't allow to move a card until all are dealt
                for (var i = 0; i < pileHand.length; i++) {
                    var card = pileHand[i];
                    if (!card.isSelected) {
                        actions.push({ command: "select", value: card.id, player: player });
                    }
                }
            }
        }
        //here..........
        if (selectedCards.length === 2) {
            actions.push({ command: "confirm", value: null, player: player });
        }
        if (this.context.canSort(player)) {
            actions.push({ command: "sort", value: null, player: player });
        }
        actions.push({ command: "playAllCribCards", value: null, player: player });

        return actions;
    }
    createMessage() {
        let dealer = this.context.dealer;
        let playerTurn = this.context.playerTurn;

        let pileCrib = this.context.getPile(this.cribPileName);
        //check if crib is full
        if (pileCrib.length === 4) {
            this.context.sendEvent("message", "", "player1");
            this.context.sendEvent("message", "", "player2");
            return;
        }
        this.context.messagePlayer1 = "";
        this.context.messagePlayer2 = "";


        //if player 1 turn send message
        let messageDealer = "Select 2 cards for YOUR crib";
        let messageNonDealer = "Select 2 cards for OPPONENT'S crib";

        let pileHand1 = this.context.getPile("hand1");
        let pileHand2 = this.context.getPile("hand2");

        //todo: remove turns
        //if (playerTurn == "player1" && pileHand1.length >= 5) {
        if (pileHand1.length >= 5) {
            if (dealer == "player1") {
                this.context.sendEvent("message", messageDealer, "player1");
                this.context.messagePlayer1 = messageDealer;
            } else {
                this.context.sendEvent("message", messageNonDealer, "player1");
                this.context.messagePlayer1 = messageNonDealer;
            }
        }
        //if (playerTurn == "player2" && pileHand2.length >= 5) {
        if (pileHand2.length >= 5) {
            if (dealer == "player2") {
                this.context.sendEvent("message", messageDealer, "player2");
                this.context.messagePlayer2 = messageDealer;
            } else {
                this.context.sendEvent("message", messageNonDealer, "player2");
                this.context.messagePlayer2 = messageNonDealer;
            }
        }
    }
    select(cardId, player) {
        let card = this.context.getCard(cardId);
        //check if played from right hand
        if (player === "player1" && card.pile !== "hand1") {
            this.invalidMove("You can only play a card from 'hand1'", player);
            return;
        }
        //check if played from right hand
        if (player === "player2" && card.pile !== "hand2") {
            this.invalidMove("You can only play a card from 'hand2'", player);
            return;
        }

        if (card.pile !== "hand1" && card.pile !== "hand2") {
            this.invalidMove("You can only select a card from your hand", player);
            return;
        }
        if (player !== "player1" && card.pile === "hand1") {
            this.invalidMove("You can only play a card from your hand", player);
            return;
        }
        if (player !== "player2" && card.pile === "hand2") {
            this.invalidMove("You can only play a card from your hand", player);
            return;
        }
        //select or remove from selected



        if (!card.isSelected) {
            let handPileName = player === "player1" ? "hand1" : "hand2";
            let handPile = this.context.getPile(handPileName);
            if (handPile.length <= 4) {
                this.invalidMove("You can not select the card.  You have already sent cards to the Crib.", player);
                return;
            }

            let selectedCards = handPile.filter(card => card.isSelected);

            if (selectedCards.length >= 2) {
                //unselect one
                let cardRandom = selectedCards[0];
                cardRandom.isSelected = false;
            }
            card.isSelected = true;
        } else {
            //deselect
            card.isSelected = false;
        }

        this.context.sendEvent("cardMoved", { 'card': card.id, 'pile': card.pile }, player);


        this.createMessage();
        return true;

    }
    sort(value, player) {
        let pileName = null;
        if (player == "player1") pileName = "hand1";
        if (player == "player2") pileName = "hand2";
        if (!pileName) return;

        let cards = this.context.getPile(pileName);
        let isSortedAscending = this.context.isPileSorted(cards, false, "number");
        if (isSortedAscending) {
            //sort Decending
            this.context.sortPile(pileName, true, "number");
        }
        let isSortedDecending = this.context.isPileSorted(cards, true, "number");
        if (isSortedDecending) {
            //shuffle
            new Deck().shuffle(cards);
            this.context.sendEvent("cardMoved");
        }
        if (!isSortedAscending && !isSortedDecending) {
            //sort Ascending
            this.context.sortPile(pileName, false, "number");
        }
        return true;
    }

    confirm(value, player) {
        let cribPileName = this.cribPileName;
        let handPileName = player === "player1" ? "hand1" : "hand2";
        let handPile = this.context.getPile(handPileName);
        let selectedCards = handPile.filter(card => card.isSelected);

        if (selectedCards.length !== 2) {
            this.invalidMove("2 Cards need to be selected to send to the crib", player);
            return;
        }
        if (handPile.length <= 4) {
            this.invalidMove("You can not select more than 2 cards for the Crib.", player);
            return;
        }

        if (selectedCards.length === 2) {
            for (var i = 0; i < selectedCards.length; i++) {
                let card = selectedCards[i];
                card.owner = "crib";
                card.showfront = true;
                this.context.addToPile(card, cribPileName, player);
            }
            //check if next players turn, then switch turns
            if (player === "player1") {
                this.context.playerTurn = "player2";
            } else {
                this.context.playerTurn = "player1";
            }
        }
        this.endState();

        this.createMessage();
        return true;
    }
    playCribCard(cardId, player) {
        // if (this.context.playerTurn !== player) {
        //     this.invalidMove("It is not your turn.");
        //     return;
        // }
        // let card = this.context.getCard(cardId);

        // //move to crib
        // card.owner = "crib";
        // card.showfront = true;
        // this.context.addToPile(card, "crib", player);
        this.createMessage();
        return true;
    }
    playAllCribCards(value, player) {
        let handPileName = player === "player1" ? "hand1" : "hand2";
        let cribPileName = this.cribPileName;

        //try sending selected cards if selected
        this.confirm(null, player);

        //send the rest of the cards from the hand
        for (let i = 0; i < 2; i++) {
            let handPile = this.context.getPile(handPileName);
            if (handPile.length > 4) {
                let card = handPile[Math.floor(Math.random() * handPile.length)];
                card.owner = "crib";
                card.showfront = true;
                this.context.addToPile(card, cribPileName, player);
            }
        }
        //switch turns
        if (player === "player1") {
            this.context.playerTurn = "player2";
        } else {
            this.context.playerTurn = "player1";
        }
        this.endState();
    }
    endState() {
        let cribPileName = this.cribPileName;

        let pileCrib = this.context.getPile(cribPileName);
        let cardsInCrib = pileCrib.length;
        //check if crib is full
        if (cardsInCrib === 4) {
            //flip all cards over (hidden)
            for (var i = 0; i < pileCrib.length; i++) {
                let card = pileCrib[i];
                card.owner = "crib";
                card.showfront = true;
            }

            //save hands and crib to round log
            this.context.logHands(null, this.preHand1, this.preHand2);
            this.context.setState("starter");
        }
    }
    invalidMove(message, player) {
        this.context.sendEvent("invalidMove", message, player);
    }
    unknownCommand(command, value, player) {
        this.context.unknownCommand(command, null, player);
    }

}